/**
 * 跨页交接：首页选中的曲谱 → 编辑器。
 *
 * 为什么不用 URL 参数或 localStorage：
 *   - URL 参数（`#edit?src=…`）得把整份曲谱塞进 hash，长谱会撑爆地址栏，也绕不开转义；
 *   - localStorage 会**覆盖访客自己的草稿** —— 那是"点错一下就丢东西"的真实数据损失路径。
 *
 * 所以用一个模块级的一次性变量：写进去、跳转、编辑器挂载时取走并清空。
 * 只在同一次页面会话里有效，刷新即失（此时编辑器已经拿到内容，本来也不需要）。
 *
 * 取用顺序见 TestApp 的 EditorPage 载入 effect：pending → 本地草稿 → 默认新谱。
 */
type PendingDoc = {
	/** 兼作曲名：编辑器 `triggerOpen` 的 `path` 就是标题 */
	title: string
	content: string
	/**
	 * 创建者署名 —— 首页样张固定 'manmantan'。编辑器保存时按它判断：
	 * 与当前用户不同 → 「保存到编曲练习库」另存副本，副本继承这个署名（出处）。
	 * 不传 = 用户自己的新谱。
	 */
	creator?: string
}

let pending: PendingDoc | null = null

export function setPendingDoc(doc: PendingDoc) {
	pending = doc
}

/** 取走并清空 —— 只能被消费一次，否则每次回到编辑器都会重放同一首 */
export function takePendingDoc(): PendingDoc | null {
	const doc = pending
	pending = null
	return doc
}
